// Environment
export const initialNodes = {
    nodes: [
        { id: '1', data: { label: 'Início' }, position: { x: 0, y: 0 }, type: 'Inicio' },
        { id: '2', data: { label: 'Fim' }, position: { x: 0, y: 300 }, type: 'Fim' }
    ],
    isExecuting: false
};

export const nodesReducer = (state = initialNodes, action) => {
    switch (action.type) {
        case "SET_NODES":
            return {
                ...state,
                nodes: action.nodes
            }
        case "SET_EXECUTING":
            return {
                ...state,
                isExecuting: action.isExecuting
            }
        default:
            return state;
    }
};
